<template>
    <div class="user-menu">

        <div class="user-menu__overlay overlay" @click="hide" v-if="show"></div>
        <transition name="popover">
            <div class="user-menu__popover" v-if="show">
                <a href="#" @click.prevent="viewSettings">Instellingen</a>
                <a href="#" @click.prevent="toggleAppAdmin" v-if="isAdmin" >{{ this.isAdminActive ? 'Naar app' : 'Naar admin' }}</a>

                <router-link :to="logout.to">{{ logout.text }}</router-link>
            </div>
        </transition>

    </div>

</template>


<script>

export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        isDemo: {
            type: Boolean,
            default: false
        },
        isAdmin: {
            type: Boolean,
            default: false,
        }
    },

    vuex: {
        actions: {
            showSettings: ({dispatch}) => {
                dispatch('SHOW_MODAL', 'Settings')
            }
        }
    },

    computed: {

        logout: function() {
            return this.isDemo
                ? { to: { name: 'logout', params: { _internal: true }, query: { next: 'web' }}, text: 'Terug naar website' }
                : { to: { name: 'logout', params: { _internal: true } }, text: 'Uitloggen' }
        },

        isAdminActive: function() {
            return window.location.pathname.substring(0, 6) == '/admin'
        },

    },

    methods: {

        hide: function(e) {
            e.preventDefault()
            e.stopPropagation()
            this.$emit('hide')
        },

        viewSettings: function() {
            this.showSettings()
        },

        toggleAppAdmin: function() {
            const location = this.isAdminActive ? '/app' : '/admin'
            return window.location.replace(location)
        },

    }

}
</script>



<style lang="scss">

    @import 'global';

    .user-menu__overlay {
        z-index: $z-index-popover;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }

    .user-menu__popover {
        $arrow-size: 10px;
        $width: 80%;
        position: absolute;
        z-index: $z-index-popover;
        top: 100%;
        left: 50%;
        width: $width;
        margin-left: -$width/2;
        margin-top: $arrow-size + 5px;
        padding: 0.7em 0;

        background-color: $color-white;
        border-radius: 4px;
        font-family: $font-body;
        box-shadow: 0 6px 15px rgba(0,0,0,0.2);


        &:after {
            content: '';
            display: block;
            position: absolute;
            top: -2*$arrow-size;
            left: 50%;
            margin-left: -$arrow-size;
            height: 0;
            width: 0;
            border: $arrow-size transparent solid;
            border-bottom-color: $color-white;

        }

        a {
            font-size: 1.8rem;
            display: block;
            padding: 0.2em 1em;
        }
    }

</style>



// WEBPACK FOOTER //
// UserMenu.vue?8e298f72